import React from 'react';
import { HelpCircle } from 'lucide-react';
import UDTippy, { UDTippyProps } from 'ud-ui/components/tippy';
import { theme } from 'styles/theme/theme';

interface HelpBubbleProps {
  content: React.ReactNode;
  placement?: UDTippyProps['placement'];
  size?: number;
}

const HelpBubble: React.FC<HelpBubbleProps> = ({ content, placement = 'top', size = 14 }) => {
  return (
    <UDTippy content={content} placement={placement} interactive>
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          color: theme.colors.Gray,
          cursor: 'help',
        }}
      >
        <HelpCircle size={size} />
      </span>
    </UDTippy>
  );
};

export default HelpBubble;
